import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  ISignBuyListInput,
  ISignBuyListResult,
  IAllBuyListFromOrganizationInput,
  IAllBuyListFromOrganizationResult,
  ISharePropertyWithBuyListsInput,
  ISharePropertyWithBuyListsResult,
  IIsBuyListCreationAllowedResult,
  IListBuyListAliasesInput,
  IListBuyListAliasesResult,
} from '@shared/models/buyers-list';

export const BUY_LIST_FRAGMENT = gql`
  fragment BuyListFragment on BuyList {
    id
    name
    allowShare
    totalInvestors
  }
`;

export const SIGN_BUY_LIST: TypedDocumentNode<
  ISignBuyListResult,
  ISignBuyListInput
> = gql`
  query signBuyList($dataType: BuyListSignDataType!) {
    signBuyList(dataType: $dataType) {
      fields
      key
      uploader
      url
    }
  }
`;

export const ALL_BUY_LIST_FROM_ORGANIZATION: TypedDocumentNode<
  IAllBuyListFromOrganizationResult,
  IAllBuyListFromOrganizationInput
> = gql`
  ${BUY_LIST_FRAGMENT}
  query allBuyListFromOrganization(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sort: [BuyListSortInput]
    $filter: BuyListFilterInput
  ) {
    allBuyListFromOrganization(
      after: $after
      before: $before
      first: $first
      last: $last
      sort: $sort
      filter: $filter
    ) {
      count
      results {
        ...BuyListFragment
      }
      # startKeyset
      # endKeyset
    }
  }
`;

export const SHARE_PROPERTY_WITH_BUY_LISTS: TypedDocumentNode<
  ISharePropertyWithBuyListsResult,
  ISharePropertyWithBuyListsInput
> = gql`
  query sharePropertyWithBuyLists(
    $buyLists: [ID!]!
    $propertyId: ID!
    $types: [BuyListShareListingType!]
  ) {
    sharePropertyWithBuyLists(
      buyLists: $buyLists
      propertyId: $propertyId
      types: $types
    )
  }
`;

export const IS_BUY_LIST_CREATION_ALLOWED: TypedDocumentNode<IIsBuyListCreationAllowedResult> = gql`
  query isBuyListCreationAllowed {
    isBuyListCreationAllowed
  }
`;

export const LIST_BUY_LIST_ALIASES: TypedDocumentNode<
  IListBuyListAliasesResult,
  IListBuyListAliasesInput
> = gql`
  query listBuyListAliases($buyListId: ID!) {
    listBuyListAliases(buyListId: $buyListId) {
      id
      firstName
      surname
      phoneNumber
      email
    }
  }
`;
